// Ask conversation title (task #5): after the first exchange the header shows a short title made from the first
// question instead of the page name. It is derived in the browser from the owner's own question and kept in page
// state only — never stored or sent anywhere, so it can only ever be visible to the conversation's owner (AC-2).
// A failure to derive one (empty or unusable text, any error) falls back to a fixed title (AC-3).

const MAX_TITLE = 60;

/** A short single-line title from the question's first meaningful line; null when nothing usable is left. */
export function conversationTitleFrom(question: string): string | null {
  try {
    const line =
      question
        .split(/\r?\n/)
        .map((l) => l.replace(/^\s*(#{1,6}\s+|[-*+>]\s+|\d+[.)]\s+|\/\w+\s*)/, "").replace(/\s+/g, " ").trim())
        .find((l) => l.length > 0) ?? "";
    if (!line) return null;
    if (line.length <= MAX_TITLE) return line;
    const cut = line.slice(0, MAX_TITLE - 1);
    const space = cut.lastIndexOf(" ");
    return `${(space > 20 ? cut.slice(0, space) : cut).trimEnd()}…`;
  } catch {
    return null;
  }
}
